import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link as MuiLink } from '@material-ui/core';
import lodashDebounce from 'lodash.debounce';
import useTranslations from '../hooks/useTranslations';

/**
 * Generates a Material UI Link element. Automatically chooses a React Router <Link>, <button>, or <a> for the root component depending on its props. If `props.debounce` is true, the onClick is debounced by `props.wait`, which defaults to 500ms.
 * @param {Object} props
 */
export default function Link(props) {
  const {
    to,
    href,
    onClick = () => {},
    content,
    children,
    debounce,
    wait = debounce ? 500 : 0
  } = props;
  const component = to ? RouterLink : href ? 'a' : 'button';

  const t = useTranslations();

  const debouncedOnClick = React.useCallback(
    lodashDebounce(onClick, wait, { leading: true, trailing: false }),
    [onClick, wait]
  );

  // button needs type="button", or it is "submit" by default
  const type = component === 'button' ? 'button' : null;

  return (
    <MuiLink
      component={component}
      type={type}
      onClick={debounce || wait ? debouncedOnClick : onClick}
      {...props}
    >
      {content ? t(content) : children}
    </MuiLink>
  );
}
